let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3wor3")).then(() => parcelRequire('b1wSl'));